import React , {Fragment } from 'react';  
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts/LayoutOne"; 
import ContactForm from '../components/ContactForm'

const ContactPage = () => {
    
    return(

        <Fragment>
            <MetaTags>
              <title> SAPIT  | Contact </title>
              <meta
                name="description"
                content=" SAPIT "
              />
            </MetaTags>

            <LayoutOne>
              {/* <PageHeader
                bgImg={require('../assets/images/page_bg.jpg')}
                title="Contact" 
              />
               */}
              <ContactForm />
 
            </LayoutOne>
        </Fragment>

      );
  }

     

export default ContactPage;   